// extracted by mini-css-extract-plugin
export default {"header":"Header_header__q5Bb8","logo":"Header_logo__QVIwU","textcolor":"Header_textcolor__1zIdo"};